import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default async function callLogoutApi() {
  const userName = localStorage.getItem("user");
  const Authorization = "bearer " + localStorage.getItem("token");

  const resp = await fetch(`${API_URL}rest/V1/rider/logout`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      logout_post: { username: userName, type: "logout" },
    }),
  })
    .then(function (response) {
      // if (!response.ok) {
      //   notify.show("Network Failure", "error");
      // }
      console.log("logresres0", response);
      if (response.status == 401) {
        return response;
      } else {
        return response.json();
      }
    })
    .then(function (result) {
      console.log("logresres", result);
      if (result && result[0] && result[0].status == "success") {
        // let action = parseInt(result[0].data.IsLoggedIn, 10);
        // action = action ? 1 : 0;
        // let mark = action ? "Mark In" : "Mark Out";
        // localStorage.setItem("mark", JSON.stringify({ mark, action }));
        // localStorage.setItem("user", result[0].data.username);
        // localStorage.setItem("rider_id", result[0].data.rider_id);
        // localStorage.setItem("vehicle_id", result[0].data.rider_id);
        // localStorage.setItem("token", result[0].data.tocken);
        // component.props.loginAction(false);
      } else {
        notify.show("Logout Failed", "error");
      }
      return result;
    });

  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/callLogoutApi.js